export const manageSubIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.tool-header',
    intro: 'The Student Subscriptions page is where you can move selected students from the WordFlight '
      + 'Screener into the WordFlight System. Teachers can review Screener results before moving students.',
  },
  {
    element: '.remaining-subscriptions',
    intro: 'See the number of System Subscriptions remaining for your classroom.',
  },
  {
    element: '.screener-results-container',
    intro: 'See the three risk categories that students are sorted into: High Risk, Some Risk, and Proficient. '
      + 'The WordFlight Screener estimates the student’s performance on the WordFlight Diagnostic and provides a '
      + 'risk category. WordFlight recommends students in the High Risk and Some Risk categories as excellent '
      + 'candidates for the WordFlight System. Students in the borderline proficient range may also benefit from '
      + 'the extra support and practice. Borderline proficiency for grades 2-4 is the range of 400-450. '
      + 'Borderline proficiency for grades 5+ is the range of 300-350. See the number of students in each '
      + 'category for each grade range.',
  },
  {
    element: '.status-overview',
    intro: 'See the number of students who have not started, started, or skipped the Screener. See the total '
      + 'number of students who have been enrolled in the Screener.',
  },
  {
    element: '.report-table thead',
    intro: 'Click on any column header to sort the column.',
  },
  {
    element: '.report-table tbody tr',
    intro: 'Select the box next to the student’s name to select them for a subscription assignment. '
      + 'Once the box is selected, the student(s) have been assigned a System Subscription. To undo '
      + 'this action, unselect the box before the student logs in.',
  }
];
